export const ARIA_LABELS = {
  // Layout
  MAIN_NAV: 'Navegación principal',
  FOOTER_NAV: 'Enlaces del pie de página',

  // Actions
  CLOSE: 'Cerrar',
  MORE_INFO: 'Más información',
  LOADING: 'Cargando',
  NEW_WINDOW: '(se abre en nueva ventana)',

  // Forms
  DATE_PICKER: 'Selector de fecha',
  REMOVE_FILE: 'Eliminar archivo'
} as const
